import { Catcher } from 'system/catcher';
import { articleModuleQuery, useModule } from 'system/structure-modules';

export default function ArticleOverlayWidget() {
    const { ArticleOverlayScreen } = useModule(articleModuleQuery);

    return (
        <Catcher>
            <ArticleOverlayScreen />
        </Catcher>
    );
}
